import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import React, { ReactElement, TextareaHTMLAttributes } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Textarea } from '../../atoms';
import { cn } from '@jobcost-monorepo/utils';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  errorName: string;
  label: string;
  inputWidth?: string;
  width?: string;
}

const TextAreaForm = ({
  name,
  errorName,
  label,
  inputWidth = 'w-full',
  width = 'w-full',
  ...rest
}: Props): ReactElement => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
    formState: { errors },
  } = useController({ control, name });
  const { t } = useTranslation('errors');
  const error = errors?.[errorName]?.message ?? '';
  const errorTranslated = t(error as string);

  return (
    <div className={cn(width)}>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 dark:text-white"
      >
        {label}
      </label>
      <div className="relative mt-1 rounded-md shadow-sm">
        <Textarea
          id={name}
          name={name}
          value={value || ''}
          onChange={onChange}
          className={cn(
            inputWidth,
            errorTranslated && 'border-red text-red placeholder-red-300',
          )}
          {...rest}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          {errorTranslated ? (
            <ExclamationCircleIcon
              className="h-5 w-5 text-red"
              aria-hidden="true"
            />
          ) : (
            <span className="h-5 w-5 " />
          )}
        </div>
      </div>
      <p className="h-4 text-xs my-1 ml-1 text-red overflow-hidden" id="error">
        {errorTranslated}
      </p>
    </div>
  );
};

export default TextAreaForm;
